import { Link } from "react-router-dom";
import { ArrowLeft, Building2, ShieldCheck } from "lucide-react";
import { PageShell } from "@/components/Shell";

const COMPANY = [
  ["Ragione sociale", "Yurax Project srl"],
  ["Sede legale", "Via Monte Napoleone, 8 – 20121 Milano (MI)"],
  ["Partita IVA e codice fiscale", "12792660966"],
  ["Numero REA", "MI-2684247"],
  ["Capitale sociale", "€ 29.900"],
  ["PEC", "yuraxproject@pec.it"],
];
const MARK = [
  ["Marchio", "Doctor Selvix"],
  ["Titolare", "[titolare del marchio]"],
  ["Numero di registrazione", "[numero di registrazione]"],
  ["Ufficio", "[UIBM / EUIPO]"],
  ["Data di registrazione", "[data di registrazione]"],
];

function Card({ icon: Icon, title, rows, id }) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm" data-testid={id}>
      <h2 className="flex items-center gap-2 font-display text-lg font-bold text-slate-900"><Icon className="h-5 w-5 text-cyan-700" />{title}</h2>
      <dl className="mt-4 divide-y divide-slate-100">
        {rows.map(([k, v]) => (
          <div key={k} className="grid gap-1 py-2.5 text-sm sm:grid-cols-[220px_1fr]">
            <dt className="font-semibold text-slate-500">{k}</dt>
            <dd className={v.startsWith("[") || v.includes("[") ? "text-amber-700" : "text-slate-900"}>{k === "PEC" ? <a href={`mailto:${v}`} className="text-cyan-700 hover:underline">{v}</a> : v}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}

export default function LegalPage() {
  return (
    <PageShell title="Note legali" subtitle="Dati societari e informazioni sul marchio Doctor Selvix." testid="legal-page">
      <Link to="/" data-testid="legal-back-home" className="mb-6 inline-flex items-center gap-1.5 text-sm font-semibold text-cyan-700 hover:underline"><ArrowLeft className="h-4 w-4" />Torna alla home</Link>
      <div className="grid max-w-4xl gap-6">
        <Card id="legal-company" icon={Building2} title="Dati societari" rows={COMPANY} />
        <Card id="legal-trademark" icon={ShieldCheck} title="Marchio" rows={MARK} />
        <p className="text-sm leading-relaxed text-slate-600" data-testid="legal-notice">
          Il progetto Doctor Selvix, il marchio, i loghi, i testi, le immagini e gli elementi grafici della piattaforma sono protetti dalle norme sulla proprietà intellettuale e industriale. Ne è vietata la riproduzione, anche parziale, senza autorizzazione scritta del titolare. Doctor Selvix è un assistente basato su AI, non un medico abilitato: in caso di emergenza chiama il 112.
        </p>
      </div>
    </PageShell>
  );
}
